export default "__VITE_ASSET__Coaw9XwT__"